import { apiPut } from '@/auth/api-client';
/**
 * Обновляет профиль на сервере (имя/аватар). Сервер — source of truth для профиля,
 * поэтому на других устройствах изменения приезжают через bootstrap.
 */
export async function updateProfile(payload) {
    return apiPut('/api/v1/me/profile', payload);
}
